import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '../Skeleton';
const MobilePrivateLoader = () => (React.createElement(Box, { "aria-label": "mobile loading", role: "presentation" },
    React.createElement(Skeleton, { variant: "rounded", width: 24, height: 24 })));
export default MobilePrivateLoader;
//# sourceMappingURL=MobilePrivateLoader.js.map